import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.grey[300],
  backgroundColor: (p) => p.palette.primary[50],
  p: (p) => p.spacing(1, 1.5),
};

export const creditInfo: SxStyle = {
  p: (p) => p.spacing(2, 1.5, 1.5, 1.5),
};
